import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import MainScene from "./MainScene";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";

export default class PanelCameras extends Phaser.GameObjects.Container {
  constructor(scene, callback) {
    super(scene);
    this.clips = [];
    this.callback = callback;
  }

  init() {
    const background = this.scene.add.image(0, 0, "fieldBack");
    background.setOrigin(0, 0);
    this.add(background);
    this.width = background.width;
    this.height = background.height;
    background.setBlendMode(Phaser.BlendModes.MULTIPLY);
    background.setInteractive();

    const field = this.scene.add.image(0, 0, "field");
    field.setOrigin(0, 0);
    this.add(field);

    const a = [];
    for (let x = 0; x < PanelCameras.CAMERAS.length; x++) {
      const { id } = PanelCameras.CAMERAS[x];
      let lFound = false;
      for (let y = 0; y < Tracking.data.videos.length; y++) {
        if (Tracking.data.videos[y].camid === id) {
          lFound = true;
        }
      }
      if (lFound) {
        a.push(PanelCameras.CAMERAS[x]);
      }
    }

    // Crea le camere
    for (let x = 0; x < a.length; x++) {
      const cam = this.scene.add.sprite(0, 0, a[x].id);
      cam.setOrigin(0, 0);
      cam.anims.play(a[x].id + "_off");
      this.add(cam);
      this.clips.push({ id: a[x].id, cam });
    }

    // Cre ail player
    const player = this.scene.add.image(0, 0, "player");
    player.setOrigin(0, 0);
    this.add(player);

    for (let x = 0; x < a.length; x++) {
      // Crea il tacun dell'hit
      const el = a[x];
      const hit = this.scene.add.rectangle(el.x - 32, el.y - 32, 117, 117, 0xffffff);
      hit.setInteractive({ useHandCursor: true });
      hit.setOrigin(0, 0);
      this.add(hit);
      hit.alpha = 0.0001;
      hit.on("pointerup", this.onChangeCam.bind(this, el.id));
      hit.on("pointerover", this.onOverCam.bind(this, x));
      hit.on("pointerout", this.onOutCam.bind(this, x));
    }

    // Il titoletto
    const txt = this.scene.add.text(0, 0, "|  SELEZIONA VISTA  |", { fontFamily: "DIN Next LT Pro", fontSize: "40px", color: this.toHexColor(ProgressBar.COLOR_BACK), align: "center", fixedWidth: this.width });
    this.add(txt);
    txt.y = 32;
    this.txt = txt;

    this.updateCam();
  }

  onOverCam(n) {
    const { id } = this.clips[n];
    if (id !== Tracking.data.videos[MainScene.that.selected].camid) {
      this.clips[n].cam.alpha = 0.5;
    }
  }

  onOutCam(n) {
    this.clips[n].cam.alpha = 1;
  }

  updateCam() {
    const id = Tracking.data.videos[MainScene.that.selected].camid;
    this.txt.setText("|  " + Tracking.data.videos[MainScene.that.selected].camdesc.toUpperCase() + "  |");
    for (let x = 0; x < this.clips.length; x++) {
      this.clips[x].cam.alpha = 1;
      if (this.clips[x].id === id) {
        this.clips[x].cam.anims.play(this.clips[x].id + "_on");
      } else {
        this.clips[x].cam.anims.play(this.clips[x].id + "_off");
      }
    }
  }

  onChangeCam(id) {
    if (!MainScene.that.tweenPanelActive) {
      if (id !== Tracking.data.videos[MainScene.that.selected].camid) {
        this.dispatch(PanelCameras.EVENT_CHANGE_CAMERA, { id });
      }
    }
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }
}

PanelCameras.CAMERAS = [
  {
    id: "cam1",
    x: 38,
    y: 801,
  },
  {
    id: "cam2",
    x: 367,
    y: 906,
  },
  {
    id: "cam3",
    x: 682,
    y: 801,
  },
  {
    id: "cam4",
    x: 66,
    y: 500,
  },
  {
    id: "cam5",
    x: 66,
    y: 650,
  },
  {
    id: "cam6",
    x: 654,
    y: 500,
  },
  {
    id: "cam7",
    x: 92,
    y: 256,
  },
  {
    id: "cam8",
    x: 353,
    y: 122,
  },
  {
    id: "cam9",
    x: 628,
    y: 256,
  },
];

PanelCameras.EVENT_CHANGE_CAMERA = "eventChangeCamera";
